export const getSafeReturnUrl = (value: string) => {
  try {
    const url = new URL(value);
    const allowedOrigin = new URL(import.meta.env.VITE_PORTAL_ORIGIN).origin;

    return url.protocol === 'https:' && url.origin === allowedOrigin
      ? url.href
      : null;
  } catch {
    return null;
  }
};
